import { ShieldAlert, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { useI18n } from "@/lib/i18n";
import { Card, CardContent } from "@/components/ui/card";

export default function UnauthorizedPage() {
    const { t } = useI18n();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
            <div className="max-w-md w-full text-center space-y-6">
                <div className="flex justify-center">
                    <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center">
                        <ShieldAlert className="h-10 w-10 text-destructive" />
                    </div>
                </div>

                <div className="space-y-2">
                    <h1 className="text-3xl font-bold tracking-tighter">{t("unauthorized.title")}</h1>
                    <p className="text-muted-foreground text-lg">
                        {t("unauthorized.desc")}
                    </p>
                </div>

                <Card className="border-destructive/20 bg-destructive/5">
                    <CardContent className="pt-6">
                        <p className="text-sm text-destructive font-medium">
                            {t("unauthorized.errorNote")}
                        </p>
                    </CardContent>
                </Card>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Link href="/">
                        <Button variant="outline" className="w-full sm:w-auto">
                            <Home className="mr-2 h-4 w-4" />
                            {t("unauthorized.backHome")}
                        </Button>
                    </Link>
                    <Link href="/login">
                        <Button className="w-full sm:w-auto">
                            {t("unauthorized.loginAgain")}
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
